<template>
    <div class="mt-3">
        <h2>Notifications</h2>

        <button class="btn btn-primary" @click="newNotificationClick">New Notification</button>


        <table class="table table-sm mt-3">
            <thead>
            <tr>
                <th>Name</th>
                <th></th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="notification in notifications">
                <td>
                    <a href="javascript:void(0)" @click="onEditClick(notification)">
                        {{notification.name}}
                    </a>
                </td>
                <td>
                    <a href="javascript:void(0)" @click="onDeleteClick(notification)">
                        <i class="fad fa-times-circle text-secondary"></i>
                    </a>
                </td>
            </tr>
            </tbody>
        </table>

        <notification-modal key="notificationModal" v-if="showNotificationModal"
                            :notification="currentNotification"
                            :email-templates="emailTemplates"
                            :notifications="notifications"
                            :yesEvent="deleteNotification"
                            @noEvent="showNotificationModal = false"></notification-modal>

        <confirm-modal
                v-if="showConfirmModal"
                @noEvent="showConfirmModal = false"
                :yesEvent="deleteNotification"
                text="Are you sure you want to delete this notification?">
        </confirm-modal>
    </div>
</template>

<script>
    import ConfirmModal from "../components/ConfirmModal.vue";
    import NotificationService from "../services/NotificationService";
    import NotificationModal from "./NotificationModal.vue";
    import EmailTemplatesService from "../services/EmailTemplatesService";

    export default {
        name: 'NotificationList',
        components: {NotificationModal, ConfirmModal},
        props: ['prop1', 'prop2'],
        data() {
            return {
                model: webase.model,
                notifications: [],
                emailTemplates: [],
                service: new NotificationService(),
                showNotificationModal: false,
                currentNotification: {
                    id: null,
                    app_id: null,
                    notification_type: '',
                    metadata: {}
                },
                showConfirmModal: false,
                deleteNotification: function () {
                }
            }
        },
        mounted() {

            this.service.list().then((response) => {
                this.notifications = response
            }).catch((message) => {
                console.log('error loading email templates')
                console.log(message)
            })

            new EmailTemplatesService().list().then((response) => {
                this.emailTemplates = response
            }).catch((message) => {
                console.log('error loading email templates')
                console.log(message)
            })

        },
        methods: {
            newNotificationClick() {
                this.currentNotification = {
                    id: null,
                    app_id: this.model.app.id,
                    name: '',
                    notification_type: '',
                    metadata: {}
                }

                this.showNotificationModal = true
            },
            onDeleteClick(notification) {
                this.showConfirmModal = true
                this.deleteNotification = () => {
                    this.service.remove(notification.id).then((response) => {
                        this.showConfirmModal = false
                        webase.utils.array.remove(this.notifications, notification.id)
                    }).catch((message) => {
                        console.log('error deleting notification')
                        console.log(message)
                        this.showConfirmModal = false
                    })
                }
            },
            onEditClick(notification) {
                this.currentNotification = notification
                this.showNotificationModal = true
            }
        }
    }
</script>

<style>

</style>
